import dynamic from 'next/dynamic';
import { useContext } from 'react';
import RecentSearches from '@/home/ReturnUser/RecentSearches';
import RecommendedCarousels from '@/home/ReturnUser/RecommendedCarousels';
import { useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/home/GlobalContext';
import HeroSectionLoader from './HeroSectionLoader';
import TopCarousels from './TopCarousels';
import BudgetFriendlyCarousel from '../common/BudgetFriendlyCarousel';
import MarketingCarousel from '../common/MarketingCarousel';
import PopularBodyStyles from '../common/PopularBodyStyles';
import PriceDropBanner from '../common/PriceDropBanner';
import ShopPopularModels from '../common/ShopPopularModels';

const HeroSection = dynamic(() => import('./HeroSection'), {
  loading: () => <HeroSectionLoader />,
  ssr: false
});

export default function ReturnUser() {
  const isNative = useIsNative();
  const { displayLowerFoldOnNative } = useContext(GlobalContext);
  const showRecommendedCarousels = isNative ? displayLowerFoldOnNative : true;

  return (
    <main data-testid="home-return-user">
      <HeroSection />
      <TopCarousels />
      <RecentSearches />
      <PriceDropBanner />
      <PopularBodyStyles />
      <BudgetFriendlyCarousel />
      {showRecommendedCarousels && <RecommendedCarousels />}
      <div className="bg-background-default">
        <MarketingCarousel />
      </div>
      <ShopPopularModels />
    </main>
  );
}
